import { defineComponent, reactive, ref, watch, toRefs } from "vue";
export default defineComponent({
  components: {},
  name: '',
  props: {
    cellData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  setup(props) {
    const state = reactive({});
    const methods = reactive({});
    return {
      ...toRefs(state),
      ...toRefs(methods)
    };
  }
});